import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Input,
  InputRightElement,
  InputGroup,
  FormLabel,
  FormControl,
} from "@chakra-ui/react";
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import imageIcon from "../../../assets/images/booking/image.svg";
import {
  InputControl,
  SelectControl,
} from "../../../components/form/formControls";
import calendarIcon from "../../../assets/images/onleave/calendar.svg";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { useCategories } from "../../../categorys/ttkq/add";
import toast from "react-hot-toast";
import { commonCall } from "../../../api/common";
import { COST_ESTIMATETYPE } from "../../../utils/globalVariable";
import { formatPriceUS } from "../../../utils/utils";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({
  // time: Yup.string().required("Vui lòng nhập ngày bắt đầu"),
  // // invoice: Yup.string().required("Phiếu tính giá là bắt buộc"),
  // paymentMethodId: Yup.string().required("Phương thức thanh toán là bắt buộc"),
  // // priceSheetImage: Yup.string().required("Ảnh phiếu tính giá là bắt buộc"),
  // customerId: Yup.string().required("Vui lòng chọn khách hàng"),
  // price: Yup.number()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string" && originalValue.trim() === "") {
  //       return null;
  //     }
  //     return Number(originalValue);
  //   })
  //   .typeError("Số tiền đóng TTKQ phải là một số hợp lệ")
  //   .moreThan(0, "Số tiền đóng TTKQ phải lớn hơn 0")
  //   .required("Vui lòng nhập số tiền đóng TTKQ"),
  // priceTime: Yup.string().required("Vui lòng nhập ngày đóng TTKQ"),
  // delegationImage: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test("check-empty", "Vui lòng chọn ảnh ủy nhiệm chi", (value) => {
  //     return Array.isArray(value) && value.length > 0;
  //   })
  //   .test("check-status", "Vui lòng chọn ảnh và upload ảnh", (value) => {
  //     if (!Array.isArray(value) || value.length === 0) return true;
  //     return value.every((img) => img.status === true);
  //   }),
  // priceSheetImage: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test("check-empty", "Vui lòng chọn ảnh phiếu tính giá", (value) => {
  //     return Array.isArray(value) && value.length > 0;
  //   })
  //   .test("check-status", "Vui lòng chọn ảnh và upload ảnh", (value) => {
  //     if (!Array.isArray(value) || value.length === 0) return true;
  //     return value.every((img) => img.status === true);
  //   }),
  // salesContractImages: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test("check-empty", "Vui lòng chọn ảnh TTKQ", (value) => {
  //     return Array.isArray(value) && value.length > 0;
  //   })
  //   .test("check-status", "Vui lòng chọn ảnh và upload ảnh", (value) => {
  //     if (!Array.isArray(value) || value.length === 0) return true;
  //     return value.every((img) => img.status === true);
  //   }),
});

const FormCreateTtkq = memo(({ isOpen, onClose, onSubmit, defaultValues }) => {
  const {
    reset,
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });

  const [focusStates, setFocusStates] = useState({});
  const [zIndex, setZIndex] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);
  const [isLoadingUpload, setIsloadingUpload] = useState(false);

  const [delegationImage, setDelegationImage] = useState([]);
  const [delegationImageError, setDelegationImageError] = useState(false);

  const [priceSheetImage, setPriceSheetImage] = useState([]);
  const [priceSheetImageError, setPriceSheetImageError] = useState(false);

  const [salesContractImages, setSalesContractImages] = useState([]);
  const [salesContractImagesError, setSalesContractImagesError] =
    useState(false);
  const imageRefs = useRef([]);

  const [displayPrice, setDisplayPrice] = useState(0);

  // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
  const handleUploadDelegationImage = async (index, selectedFile) => {
    const file = selectedFile || delegationImage[index]?.file;
    if (!file) return;

    // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
    const updateImage = (data) =>
      setDelegationImage((prev) => {
        const position = prev.findIndex((item) => item?.file === file);
        if (position < 0) return prev;
        const updated = [...prev];
        updated[position] = { ...updated[position], ...data };
        return updated;
      });

    updateImage({ uploading: true });

    try {
      const { filePath } = await commonCall.uploadFile(
        file,
        "salesContractImage"
      );

      if (filePath) {
        updateImage({ path: filePath, status: true, uploading: false });
        toast.success("Upload ảnh thành công");
        clearErrors("delegationImage");
      } else {
        updateImage({ uploading: false });
        toast.error("Upload thất bại");
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast
      updateImage({ uploading: false });
    }
  };

  // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
  const handleUploadPriceSheetImage = async (index, selectedFile) => {
    const file = selectedFile || priceSheetImage[index]?.file;
    if (!file) return;

    // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
    const updateImage = (data) =>
      setPriceSheetImage((prev) => {
        const position = prev.findIndex((item) => item?.file === file);
        if (position < 0) return prev;
        const updated = [...prev];
        updated[position] = { ...updated[position], ...data };
        return updated;
      });

    updateImage({ uploading: true });

    try {
      const { filePath } = await commonCall.uploadFile(
        file,
        "salesContractImage"
      );

      if (filePath) {
        updateImage({ path: filePath, status: true, uploading: false });
        toast.success("Upload ảnh thành công");
        clearErrors("priceSheetImage");
      } else {
        updateImage({ uploading: false });
        toast.error("Upload thất bại");
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast
      updateImage({ uploading: false });
    }
  };

  // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
  const handleUploadSalesContractImage = async (index, selectedFile) => {
    const file = selectedFile || salesContractImages[index]?.file;
    if (!file) return;

    // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
    const updateImage = (data) =>
      setSalesContractImages((prev) => {
        const position = prev.findIndex((item) => item?.file === file);
        if (position < 0) return prev;
        const updated = [...prev];
        updated[position] = { ...updated[position], ...data };
        return updated;
      });

    updateImage({ uploading: true });

    try {
      const { filePath } = await commonCall.uploadFile(
        file,
        "salesContractImage"
      );

      if (filePath) {
        updateImage({ path: filePath, status: true, uploading: false });
        toast.success("Upload ảnh thành công");
        setSalesContractImagesError(false);
      } else {
        updateImage({ uploading: false });
        toast.error("Upload thất bại");
      }
    } catch (error) {
      // commonCall.uploadFile đã báo lỗi bằng toast
      updateImage({ uploading: false });
    }
  };

  // useEffect(() => {
  //   reset(defaultValues);
  //   setDelegationImage({});
  // }, [isOpen]);
  useEffect(() => {
    reset(defaultValues);
    if (defaultValues?.id) {
      const fetchData = async () => {
        try {
          setDelegationImage([]);
          setPriceSheetImage([]);
          setSalesContractImages([]);

          if (defaultValues?.delegationImage?.length) {
            const initImages = defaultValues.delegationImage.map(
              (path, idx) => ({
                id: Date.now() + idx,
                path,
                imageUrl: null,
                file: null,
                status: true, // ảnh đã upload
              })
            );
            setDelegationImage(initImages);
          }

          if (defaultValues?.priceSheetImage?.length) {
            const initImages = defaultValues.priceSheetImage?.map(
              (path, idx) => ({
                id: Date.now() + idx,
                path,
                imageUrl: null,
                file: null,
                status: true, // ảnh đã upload
              })
            );
            setPriceSheetImage(initImages);
          }

          if (defaultValues?.salesContractImages?.length) {
            const initImages = defaultValues.salesContractImages.map(
              (path, idx) => ({
                id: Date.now() + idx,
                path,
                imageUrl: null,
                file: null,
                status: true, // ảnh đã upload
              })
            );
            setSalesContractImages(initImages);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    } else {
      setDisplayPrice(formatPriceUS(0));
    }
  }, [isOpen]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setValue("delegationImage", delegationImage);
    if (
      delegationImage?.length > 0 &&
      delegationImage?.filter((img) => img.status === false)
    ) {
      setDelegationImageError(true);
    } else {
      setDelegationImageError(false);
    }
  }, [delegationImage, setValue]);

  useEffect(() => {
    setValue("priceSheetImage", priceSheetImage);
    if (
      priceSheetImage?.length > 0 &&
      priceSheetImage?.filter((img) => img.status === false)
    ) {
      setPriceSheetImageError(true);
    } else {
      setPriceSheetImageError(false);
    }
  }, [priceSheetImage, setValue]);

  useEffect(() => {
    setValue("salesContractImages", salesContractImages);
    if (
      salesContractImages?.length > 0 &&
      salesContractImages?.filter((img) => img.status === false)
    ) {
      setSalesContractImagesError(true);
    } else {
      setSalesContractImagesError(false);
    }
  }, [salesContractImages, setValue]);

  const { constantData } = useCategories(
    null,
    null,
    1,
    defaultValues?.bookerId,
    shouldFetch
  );

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({
      value: key,
      label: value,
    }));

  const paymentMethods = useMemo(
    () => formatEntries(constantData?.paymentMethod),
    [constantData?.paymentMethod]
  );

  const customers = useMemo(
    () => formatEntries(constantData?.customer),
    [constantData?.customer]
  );

  const handleFocus = (field, index) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field, index) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const handleDateChange = (e, inputName) => {
    setValue(inputName, e, { shouldValidate: true });
  };

  // const onchangePaymentMethod = (option) => {
  //   setValue("paymentMethodId", option);
  // };

  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayPrice(formatPriceUS(numericValue));
      setValue("price", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS]
  );

  const changeImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setDelegationImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("delegationImage");
      };

      reader.readAsDataURL(file);
    }
  };

  //DelegationImage anh UNC
  const changeDelegationImage = (event, type, id) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      const imageUrl = URL.createObjectURL(file);

      reader.onload = (e) => {
        setDelegationImage((prev) => ({
          ...prev,
          id: id || Date.now(),
          imageUrl: imageUrl,
          file: file,
          status: false,
        }));
        clearErrors("delegationImage");
      };

      reader.readAsDataURL(file);
    }
  };

  const handleAddDelegationImage = () => {
    setDelegationImage((prev) => {
      const newImage = {
        id: Date.now(),
        path: null,
        imageUrl: null,
        file: null,
        status: false,
      };

      setTimeout(() => {
        const index = prev?.length; // index mới
        imageRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100); // để DOM cập nhật xong mới scroll

      return [...prev, newImage];
    });
  };

  const handleChangeDelegationImage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    const updated = [...delegationImage];
    updated[index] = {
      ...updated[index],
      file,
      imageUrl,
      status: false,
      path: null,
    };
    setDelegationImage(updated);
    handleUploadDelegationImage(index, file);
  };

  const onchangeCustomer = (option) => {
    setValue("customerId", option);
  };

  const handleRemoveDelegationImage = (index) => {
    const updated = [...delegationImage];
    updated.splice(index, 1);
    setDelegationImage(updated);
    if (delegationImage?.length === 0) {
      setDelegationImageError(false);
    }
  };
  //DelegationImage anh UNC

  //ảnh phiếu tính giá

  const handleAddPriceSheetImage = () => {
    setPriceSheetImage((prev) => {
      const newImage = {
        id: Date.now(),
        path: null,
        imageUrl: null,
        file: null,
        status: false,
      };

      setTimeout(() => {
        const index = prev?.length; // index mới
        imageRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100); // để DOM cập nhật xong mới scroll

      return [...prev, newImage];
    });
  };

  const handleChangePriceSheetImage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    const updated = [...priceSheetImage];
    updated[index] = {
      ...updated[index],
      file,
      imageUrl,
      status: false,
      path: null,
    };
    setPriceSheetImage(updated);
    handleUploadPriceSheetImage(index, file);
  };

  const handleRemovePriceSheetImage = (index) => {
    const updated = [...priceSheetImage];
    updated.splice(index, 1);
    setPriceSheetImage(updated);
    if (priceSheetImage?.length === 0) {
      setPriceSheetImageError(false);
    }
  };

  //Kết thúc ảnh phiếu tính giá

  //ảnh TTKQ
  const handleAddSalesContractImage = () => {
    setSalesContractImages((prev) => {
      const newImage = {
        id: Date.now(),
        path: null,
        imageUrl: null,
        file: null,
        status: false,
      };

      setTimeout(() => {
        const index = prev?.length; // index mới
        imageRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, 100); // để DOM cập nhật xong mới scroll

      return [...prev, newImage];
    });
  };

  const handleChangeSalesContractImage = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const imageUrl = URL.createObjectURL(file);
    const updated = [...salesContractImages];
    updated[index] = {
      ...updated[index],
      file,
      imageUrl,
      status: false,
      path: null,
    };
    setSalesContractImages(updated);
    handleUploadSalesContractImage(index, file);
  };

  const handleRemoveSalesContractImage = (index) => {
    const updated = [...salesContractImages];
    updated.splice(index, 1);
    setSalesContractImages(updated);
    if (salesContractImages?.length === 0) {
      setSalesContractImagesError(false);
    }
  };
  //Kết thúc ảnh TTKQ

  const onchangePaymentMethod = (option) => {
    setValue("paymentMethodId", option);
  };

  // const onchangeInvoice = (option) => {
  //   setValue("invoice", option);
  // };

  const getLabelFromValue = (value) => {
    const item = COST_ESTIMATETYPE.find((item) => item.value === value);
    return item ? item.label : null;
  };

  const submitHandler = (data) => {
    if (delegationImage?.length > 0) {
      data.delegationImage = delegationImage
        .filter((img) => img?.path)
        .map((img) => img.path);
    } else {
      data.delegationImage = [];
    }
    if (priceSheetImage?.length > 0) {
      data.priceSheetImage = priceSheetImage
        .filter((img) => img?.path)
        .map((img) => img.path);
    } else {
      data.priceSheetImage = [];
    }
    if (salesContractImages?.length > 0) {
      data.salesContractImages = salesContractImages
        .filter((img) => img?.path)
        .map((img) => img.path);
    } else {
      data.salesContractImages = [];
    }

    // if (data?.invoice) {
    //   const invoice = getLabelFromValue(data?.invoice);

    //   if (invoice) {
    //     data.invoice = invoice;
    //   }
    // }
    onSubmit(data);
    // if (delegationImage?.id) {
    //   data.delegationImage = delegationImage;
    //   onSubmit(data);
    // } else {
    //   setError("delegationImage", {
    //     message: "Vui lòng chọn ảnh ủy nhiệm chi.",
    //   });
    // }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Box
            paddingBottom={"80px"}
            h={"86.5vh"}
            w={"100%"}
            overflowY={"scroll"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Chuyển TTKQ
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box margin={"0 auto"}>
              <Box p={"24px 40px"}>
                <Box flex={1}>
                  <Box>
                    <Box mt={"16px"} borderRadius={"8px"}>
                      <Flex mt={"16px"} gap={"27px"}>
                        <InputControl
                          label="Tên TTKQ"
                          placeholder="Nhập tên TTKQ"
                          errors={errors.name}
                          register={register("name")}
                          onFocus={() => handleFocus("name")}
                          onBlur={() => handleBlur("name")}
                          state={focusStates["name"]}
                          mwidth="100%"
                          // // isRequired={true}
                        />
                      </Flex>

                      <Flex mt={"16px"}>
                        <FormControl
                          flex={1}
                          zIndex={zIndex === "time" ? 3 : 1}
                        >
                          <FormLabel
                            mb={"6px"}
                            fontSize={{ base: "12px" }}
                            fontWeight={400}
                            color={
                              focusStates["startTime"]
                                ? "var(--color-option-employee-hover)"
                                : "var(--color-label-employee)"
                            }
                          >
                            <Flex alignItems="center" gap="4px">
                              Ngày ký TTKQ
                              {/* <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text> */}
                            </Flex>
                          </FormLabel>
                          <InputGroup>
                            <DatePicker
                              width="100%"
                              selected={watch("time")}
                              onChange={(date) =>
                                handleDateChange(date, "time")
                              }
                              dateFormat="dd/MM/yyyy"
                              locale="vi"
                              placeholderText="dd/mm/yy"
                              className="custom-datepicker datePickerStyle"
                              onFocus={() => {
                                setZIndex("time");
                                handleFocus("time", "time");
                              }}
                              onBlur={() => handleBlur("time")}
                            />
                            <InputRightElement pointerEvents="none" h={"44px"}>
                              <Image src={calendarIcon} />
                            </InputRightElement>
                          </InputGroup>
                          {errors.time && (
                            <Text fontSize={{ base: "12px" }} color={"red"}>
                              {errors.time.message}
                            </Text>
                          )}
                        </FormControl>
                      </Flex>

                      <Flex mt={"16px"} gap={"27px"}>
                        <InputControl
                          // type="number"
                          label="Số tiền đóng TTKQ"
                          placeholder="Ví dụ: 1 tỷ 950 triệu "
                          errors={errors.price}
                          register={register("price")}
                          onFocus={() => handleFocus("price")}
                          onBlur={() => handleBlur("price")}
                          state={focusStates["price"]}
                          onChange={onChangePrice}
                          value={displayPrice}
                          mwidth={"100%"}
                          // isRequired={true}
                        />
                      </Flex>

                      <Flex mt={"16px"}>
                        <FormControl
                          flex={1}
                          zIndex={zIndex === "priceTime" ? 3 : 1}
                        >
                          <FormLabel
                            mb={"6px"}
                            fontSize={{ base: "12px" }}
                            fontWeight={400}
                            color={
                              focusStates["startTime"]
                                ? "var(--color-option-employee-hover)"
                                : "var(--color-label-employee)"
                            }
                          >
                            <Flex alignItems="center" gap="4px">
                              Ngày đóng tiền TTKQ
                              {/* <Text
                                fontSize={{ base: "12px" }}
                                color={"red"}
                                lineHeight={"15px"}
                              >
                                *
                              </Text> */}
                            </Flex>
                          </FormLabel>
                          <InputGroup>
                            <DatePicker
                              width="100%"
                              selected={watch("priceTime")}
                              onChange={(date) =>
                                handleDateChange(date, "priceTime")
                              }
                              dateFormat="dd/MM/yyyy"
                              locale="vi"
                              placeholderText="dd/mm/yy"
                              className="custom-datepicker datePickerStyle"
                              onFocus={() => {
                                setZIndex("priceTime");
                                handleFocus("priceTime", "priceTime");
                              }}
                              onBlur={() => handleBlur("priceTime")}
                            />
                            <InputRightElement pointerEvents="none" h={"44px"}>
                              <Image src={calendarIcon} />
                            </InputRightElement>
                          </InputGroup>
                          {errors.priceTime && (
                            <Text fontSize={{ base: "12px" }} color={"red"}>
                              {errors.priceTime.message}
                            </Text>
                          )}
                        </FormControl>
                      </Flex>

                      {/* <Flex mt={"16px"} gap={"27px"}> */}
                        {/* <InputControl
                          label="Phiếu tính giá"
                          placeholder="Nhập phiếu tính giá"
                          errors={errors.invoice}
                          register={register("invoice")}
                          onFocus={() => handleFocus("invoice")}
                          onBlur={() => handleBlur("invoice")}
                          state={focusStates["invoice"]}
                          mwidth="100%"
                          // isRequired={true}
                        /> */}
                        {/* <SelectControl
                          label="Phiếu tính giá"
                          placeholder="Nhập phiếu tính giá"
                          dataOption={COST_ESTIMATETYPE}
                          selectedMain={watch("invoice")}
                          onChange={onchangeInvoice}
                          onFocus={() => handleFocus("invoice")}
                          onBlur={() => handleBlur("invoice")}
                          state={focusStates["invoice"]}
                          registerProps={register("invoice")}
                          errorMessage={errors.invoice}
                          mwidth="100%"
                          isSearchable={true}
                          // isRequired={true}
                        /> */}
                      {/* </Flex> */}
                      <Flex mt={"16px"} gap={"27px"}>
                        <SelectControl
                          label="Phương thức thanh toán"
                          dataOption={paymentMethods}
                          placeholder="Chọn phương thức thanh toán"
                          selectedMain={watch("paymentMethodId")}
                          onChange={onchangePaymentMethod}
                          onFocus={() => handleFocus("paymentMethodId")}
                          onBlur={() => handleBlur("paymentMethodId")}
                          state={focusStates["paymentMethodId"]}
                          registerProps={register("paymentMethodId")}
                          errorMessage={errors.paymentMethodId}
                          mwidth="100%"
                          isSearchable={true}
                          // isRequired={true}
                        />
                      </Flex>
                      <Flex mt={"16px"} gap={"27px"}>
                        <SelectControl
                          label="Khách hàng"
                          dataOption={customers}
                          placeholder="Chọn khách hàng"
                          selectedMain={watch("customerId")}
                          onChange={onchangeCustomer}
                          onFocus={() => handleFocus("customerId")}
                          onBlur={() => handleBlur("customerId")}
                          state={focusStates["customerId"]}
                          registerProps={register("customerId")}
                          errorMessage={errors.customerId}
                          mwidth="100%"
                          isSearchable={true}
                          // isRequired={true}
                        />
                      </Flex>
                    </Box>
                  </Box>
                </Box>

                {/* Ảnh UNC mới */}
                <Box flex={1} mt={"24px"}>
                  <Box mt={6}>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh ủy nhiệm chi
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Button size="sm" onClick={handleAddDelegationImage}>
                        + Thêm ảnh
                      </Button>
                    </Flex>

                    {delegationImage.map((img, index) => (
                      <Box
                        key={img.id || index}
                        mb={4}
                        ref={(el) => (imageRefs.current[index] = el)}
                      >
                        <Flex
                          border="1px solid #ccc"
                          borderRadius="8px"
                          p={2}
                          align="center"
                          gap={4}
                          position={"relative"}
                          justifyContent={"center"}
                        >
                          <Box w="100%" h="200px" position="relative">
                            {img.imageUrl || img.path ? (
                              <Image
                                src={img.imageUrl || `${baseURL}/${img.path}`}
                                objectFit="contain"
                                w="100%"
                                h="100%"
                                borderRadius="8px"
                              />
                            ) : (
                              <Text
                                fontSize="sm"
                                color="gray.400"
                                textAlign="center"
                                mt="80px"
                              >
                                Chưa có ảnh
                              </Text>
                            )}

                            <Input
                              type="file"
                              accept="image/*"
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              w="100%"
                              h="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                handleChangeDelegationImage(e, index)
                              }
                            />
                          </Box>

                          <Box
                            position="absolute"
                            top="8px"
                            right="8px"
                            zIndex={2}
                          >
                            <Button
                              size="sm"
                              colorScheme="red"
                              onClick={() => handleRemoveDelegationImage(index)}
                            >
                              Xóa
                            </Button>
                          </Box>
                        </Flex>
                        {!img.imageUrl && !img?.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            Vui lòng chọn ảnh
                          </Text>
                        )}
                        {img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            {img.uploading
                              ? "Đang tải ảnh lên..."
                              : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                          </Text>
                        )}
                        <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                          {!img.status && img.file && (
                            <Button
                              bg={"var(--linear-gradient-employee)"}
                              color={"var(--color-main)"}
                              fontSize={"12px"}
                              lineHeight={"17px"}
                              // p={"6px 27px 5px 28px"}
                              fontWeight={"600"}
                              _hover={{
                                filter: "brightness(90%)",
                              }}
                              onClick={() => handleUploadDelegationImage(index)}
                              isDisabled={!img.file}
                              h={"28px"}
                              minH={"28px"}
                              w={"90px"}
                              isLoading={isLoadingUpload || img.uploading}
                            >
                              Tải lại
                            </Button>
                          )}
                        </Flex>
                      </Box>
                    ))}

                    {errors?.delegationImage?.message &&
                      !delegationImageError && (
                        <Text fontSize="12px" color="red" lineHeight={"15px"}>
                          {errors?.delegationImage?.message}
                        </Text>
                      )}
                  </Box>
                </Box>

                {/* Ảnh phiếu tính giá */}
                <Box flex={1} mt={"24px"}>
                  <Box mt={6}>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh phiếu tính giá
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Button size="sm" onClick={handleAddPriceSheetImage}>
                        + Thêm ảnh
                      </Button>
                    </Flex>

                    {priceSheetImage.map((img, index) => (
                      <Box
                        key={img.id || index}
                        mb={4}
                        ref={(el) => (imageRefs.current[index] = el)}
                      >
                        <Flex
                          border="1px solid #ccc"
                          borderRadius="8px"
                          p={2}
                          align="center"
                          gap={4}
                          position={"relative"}
                          justifyContent={"center"}
                        >
                          <Box w="100%" h="200px" position="relative">
                            {img.imageUrl || img.path ? (
                              <Image
                                src={img.imageUrl || `${baseURL}/${img.path}`}
                                objectFit="contain"
                                w="100%"
                                h="100%"
                                borderRadius="8px"
                              />
                            ) : (
                              <Text
                                fontSize="sm"
                                color="gray.400"
                                textAlign="center"
                                mt="80px"
                              >
                                Chưa có ảnh
                              </Text>
                            )}

                            <Input
                              type="file"
                              accept="image/*"
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              w="100%"
                              h="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                handleChangePriceSheetImage(e, index)
                              }
                            />
                          </Box>

                          <Box
                            position="absolute"
                            top="8px"
                            right="8px"
                            zIndex={2}
                          >
                            <Button
                              size="sm"
                              colorScheme="red"
                              onClick={() => handleRemovePriceSheetImage(index)}
                            >
                              Xóa
                            </Button>
                          </Box>
                        </Flex>
                        {!img.imageUrl && !img?.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            Vui lòng chọn ảnh
                          </Text>
                        )}
                        {img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            {img.uploading
                              ? "Đang tải ảnh lên..."
                              : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                          </Text>
                        )}
                        <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                          {!img.status && img.file && (
                            <Button
                              bg={"var(--linear-gradient-employee)"}
                              color={"var(--color-main)"}
                              fontSize={"12px"}
                              lineHeight={"17px"}
                              // p={"6px 27px 5px 28px"}
                              fontWeight={"600"}
                              _hover={{
                                filter: "brightness(90%)",
                              }}
                              onClick={() => handleUploadPriceSheetImage(index)}
                              isDisabled={!img.file}
                              h={"28px"}
                              minH={"28px"}
                              w={"90px"}
                              isLoading={isLoadingUpload || img.uploading}
                            >
                              Tải lại
                            </Button>
                          )}
                        </Flex>
                      </Box>
                    ))}

                    {errors?.priceSheetImage?.message &&
                      !priceSheetImageError && (
                        <Text fontSize="12px" color="red" lineHeight={"15px"}>
                          {errors?.priceSheetImage?.message}
                        </Text>
                      )}
                  </Box>
                </Box>

                {/* Ảnh HDMB */}
                <Box flex={1} mt={"24px"}>
                  <Box mt={6}>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh TTKQ
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>
                      <Button size="sm" onClick={handleAddSalesContractImage}>
                        + Thêm ảnh
                      </Button>
                    </Flex>

                    {salesContractImages.map((img, index) => (
                      <Box
                        key={img.id || index}
                        mb={4}
                        ref={(el) => (imageRefs.current[index] = el)}
                      >
                        <Flex
                          border="1px solid #ccc"
                          borderRadius="8px"
                          p={2}
                          align="center"
                          gap={4}
                          position={"relative"}
                          justifyContent={"center"}
                        >
                          <Box w="100%" h="200px" position="relative">
                            {img.imageUrl || img.path ? (
                              <Image
                                src={img.imageUrl || `${baseURL}/${img.path}`}
                                objectFit="contain"
                                w="100%"
                                h="100%"
                                borderRadius="8px"
                              />
                            ) : (
                              <Text
                                fontSize="sm"
                                color="gray.400"
                                textAlign="center"
                                mt="80px"
                              >
                                Chưa có ảnh
                              </Text>
                            )}

                            <Input
                              type="file"
                              accept="image/*"
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              w="100%"
                              h="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                handleChangeSalesContractImage(e, index)
                              }
                            />
                          </Box>

                          <Box
                            position="absolute"
                            top="8px"
                            right="8px"
                            zIndex={2}
                          >
                            <Button
                              size="sm"
                              colorScheme="red"
                              onClick={() =>
                                handleRemoveSalesContractImage(index)
                              }
                            >
                              Xóa
                            </Button>
                          </Box>
                        </Flex>
                        {!img.imageUrl && !img?.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            Vui lòng chọn ảnh
                          </Text>
                        )}
                        {img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            {img.uploading
                              ? "Đang tải ảnh lên..."
                              : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                          </Text>
                        )}
                        <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                          {!img.status && img.file && (
                            <Button
                              bg={"var(--linear-gradient-employee)"}
                              color={"var(--color-main)"}
                              fontSize={"12px"}
                              lineHeight={"17px"}
                              // p={"6px 27px 5px 28px"}
                              fontWeight={"600"}
                              _hover={{
                                filter: "brightness(90%)",
                              }}
                              onClick={() =>
                                handleUploadSalesContractImage(index)
                              }
                              isDisabled={!img.file}
                              h={"28px"}
                              minH={"28px"}
                              w={"90px"}
                              isLoading={isLoadingUpload || img.uploading}
                            >
                              Tải lại
                            </Button>
                          )}
                        </Flex>
                      </Box>
                    ))}
                    {errors?.salesContractImages?.message &&
                      !salesContractImagesError && (
                        <Text fontSize="12px" color="red" lineHeight={"15px"}>
                          {errors?.salesContractImages?.message}
                        </Text>
                      )}
                  </Box>
                </Box>
                {/* Kết thúc ảnh */}
              </Box>
            </Box>
            <Box
              position={"absolute"}
              w={"100%"}
              bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  borderRadius={"8px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={onClose}
                >
                  Hủy
                </Button>
                <Button
                  type="submit"
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Box>
          </Box>
        </form>
      </ModalContent>
    </Modal>
  );
});

export default FormCreateTtkq;
